<template>
  <div class="right-side">
    <div class="title">
      <span class="item" :class="current=='schedule'?'active':''" @click="current='schedule'">大会议程</span>
      <span class="item" :class="current=='file'?'active':''" @click="current='file'">资料下载</span>
    </div>

    <div class="video-schedule" v-show="current=='schedule'" :class="webinarInfo.replaySwitch == 1?'replay':''">
      <GeminiScrollbar :autoshow="true" style="padding-top: 3px">
        <div class="video-schedule-box">
          <div class="schedule-list">
            <div class="item" @click="checkReplay(list,index)" v-for="(list,index) in originScheduleList" :key="list.agendaId">
              <div class="box" :class="list.isCurrent?'current':''" :style="{'display':list.agendaGuest && list.agendaGuest.length>0?'block':'flex'}">
                <span class="current-icon"></span>
                <!--<div class="date">{{ list.startTimeDate }}-{{ list.endTimeDate }}</div>-->
                <div class="theme-title">{{ list.theme.replace('|&|','') }}</div>
                <div class="middle-time" v-show="!list.agendaGuest || list.agendaGuest.length == 0">{{ list.startTimeDate }}-{{ list.endTimeDate }}</div>
                <div v-show="list.agendaGuest && list.agendaGuest.length>0" v-for="(guest, i) in list.agendaGuest"
                     :key="i">
                  <div class="member">
                    <div class="data">
                      <div>{{ list.startTimeDate }}</div>
                      <div>-</div>
                      <div>{{ list.endTimeDate }}</div>
                    </div>
                    <div class="head">
                      <div class="head-box">
                        <img class="head-img" :src="guest.head" alt="">
                      </div>
                    </div>
                    <div class="right-item">
                      <div class="name">{{ guest.name }}</div>
                      <div class="position">{{ guest.enterprise }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </GeminiScrollbar>
    </div>
    <div class="video-schedule" v-show="current=='file'">
      <GeminiScrollbar :autoshow="true">
        <div class="video-schedule-box">
          <div class="schedule-list">
            <div class="item-file"  v-for="list in fileList" :key="list.fileId">
              <img src="../../assets/images/file-icon2.png" alt="" class="file-icon">
              <div class="title">
                {{list.name}}
              </div>
              <img class="file-down" src="../../assets/images/file-down-new.png" @click="down(list)" alt="下载">
            </div>
          </div>
        </div>
      </GeminiScrollbar>
    </div>

  </div>
</template>

<script>
import {$subscriber, cr, ck} from 'fire-wind-water';
import ws from "../../services/webinar";
import moment from 'moment';
import $ from "jquery";

export default {
  name: 'Schedule',
  data() {
    return {
      originScheduleList:[],
      amList: [],
      pmList: [],
      showList: [],
      replaySwitch: 0,
      isAm:true,
      current:'schedule',
      fileList:[],
      webinarInfo:{},
      hasParticipation:false,
      isShowQuestion:false,
      user:{},
      getTimeLine:null
    };
  },
  created() {
    this.init();
  },
  computed: {
    scheduleList() {
      let newAgendaList = [];
      for (let i in window.agendaGroup) {
        console.log(i)    //输出 ： a   b  c
        newAgendaList.push({
          agendaId: Math.random(),
          name: i,
          item: this.getAgendaGroup(this.originScheduleList, window.agendaGroup[i])
        })
      }
      return  newAgendaList;
    }
  },
  methods: {
    init() {
      let _this=this;
      $subscriber.subscribe('webinarInfo', data => {
        let index = 0;
        this.webinarInfo = data;
        this.getFile();
        //把嘉宾的数据 和日常的数据组合一下
        this.replaySwitch = data.replaySwitch;
        cr.each(data.agendaList, d => {
          d.endTimeDate = moment(d.endTime * 1000).format('HH:mm');
          d.startTimeDate = moment(d.startTime * 1000).format('HH:mm');
          cr.each(d.agendaGuest, n => {
            cr.each(data.guestList, list => {
              if (list.webinarGuestId == n.webinarGuestId) {
                n.duty = list.duty; //"这是职务"
                n.enterprise = list.enterprise; //"这是公司"
                n.department = list.department; //"这是部门"
                n.head = list.realPath;
              }
            });
          });
        });
        let nuanchangNum = 0;

        cr.each({...data.agendaList}, (d,i) => {

          if (d.theme.indexOf('|&|') > -1) {
            // d.theme = d.theme.replace('|&|','');
            d.isCurrent = true;
            index = i;
          } else {
            d.isCurrent = false;
          }
          d.theme=d.theme.replaceAll('^|^','')
        })

        // this.amList[1].isCurrent = true;
        if(parseInt(window.currentGuestIndex)>-1 && data.agendaList[parseInt(window.currentGuestIndex)]){
          data.agendaList[parseInt(window.currentGuestIndex)].isCurrent = true;
          index = window.currentGuestIndex
        }
        data.agendaList.forEach((item,index)=>{
          item.timestamp = window.agendaTimestamp[index]
        });
this.originScheduleList = data.agendaList
      console.log('this.originScheduleList',this.originScheduleList);

/*        this.scheduleList = data.agendaList;*/
        // let currentTime = new Date().getTime();
        setTimeout(()=>{
          if(index>=3 && index<7){
            console.log($(".video-schedule .item").outerHeight()*3);
            $(".video-schedule .gm-scroll-view").scrollTop($(".video-schedule .item").outerHeight()*3);
          }else if(index>=7 && index<10){
            $(".video-schedule .gm-scroll-view").scrollTop($(".video-schedule .item").outerHeight()*6);
          }
          else if(index>=10 ){
            $(".video-schedule .gm-scroll-view").scrollTop($(".video-schedule .item").outerHeight()*8);
          }
        },1000)

      });
      $subscriber.subscribe("onTimeline", (data) => {
        let index = -1;
        if (data.content.indexOf('timeline') > -1) {
          index = parseInt(data.content.replace('timeline','')) - 1;
        }
        if (index > -1) {
          cr.each(this.originScheduleList, d => {
            d.isCurrent = false;
          })
          this.originScheduleList[index].isCurrent = true;
        }

        this.originScheduleList = {...this.originScheduleList};
        if(index>=3 && index<7){
          console.log($(".video-schedule .item").outerHeight()*3);
          $(".video-schedule .gm-scroll-view").scrollTop($(".video-schedule .item").outerHeight()*3);
        }else if(index>=7 && index<10){
          $(".video-schedule .gm-scroll-view").scrollTop($(".video-schedule .item").outerHeight()*6);
        }
        else if(index>=10 ){
          $(".video-schedule .gm-scroll-view").scrollTop($(".video-schedule .item").outerHeight()*8);
        }
      });
      $subscriber.subscribe("setHasParticipation", () => {
        self.hasParticipation = true;
      });
      $subscriber.subscribe("onQuestionnaire", data => {
        if(data.length>0){
          this.isShowQuestion = true;
        }
      });
      $subscriber.subscribe("onPublishQuestionnaire", data => {
        if(data.length>0){
          this.isShowQuestion = true;
        }
      });
      $subscriber.subscribe("userInfo", data => {
        this.user = data;
      });
      $subscriber.subscribe("simulateClickEvent", data=>{
        this.scheduleList = this.scheduleList.map(item2=>{
          item2.isCurrent = false;
          return item2;
        })
        if(data.idx && this.scheduleList[data.idx] && this.scheduleList[data.idx]){
          this.scheduleList[data.idx].isCurrent = true;
        }
      });
      window.$sk.webinar.module({
        skPlayerStatus(res) {
          let data = res[0];
          if (data.content.data == "直播回放") {
            let time=''
            this.getTimeLine =  setInterval(()=>{
              if(window.$sk.webinar.sdk.player.nowVideo.videoType=='0'){
                time= window.$sk.webinar.sdk.player.plvLiveSdk.player.player.currentTime;
              }else {
                time= window.$sk.webinar.sdk.player.plvDomainSdk.j2s_getCurrentTime();
              }
              _this.getCurrentAgenda(time);
            },1000)

          }
        },
      })
    },
    getFile() {

      let params = {
        name: "",
        folderId: this.webinarInfo.folderId || 0,
        instanceId: this.webinarInfo.instanceId,
        tenantId: this.webinarInfo.tenantId,
        __module__: 2,
        __objId__: this.webinarInfo.webinarId,
        __typeArr__: ["folder"] // 通过文件夹ID获取，对应的是静态地址规则：file/folder/info
      };
      ws.getResource(params).subscribe(data => {
        data.content.items=data.content.items.sort((a,b)=>{
          return a.order-b.order
        })
        this.fileList = data.content.items;
      });
    },
    down(item){
      ws.isAllQuestionJoin({
        "quesitonary": [this.webinarInfo.customFieldObject.questionId, this.webinarInfo.customFieldObject.questionId2],
        globalUserId: ck.cookie("globalUserId"),
      }).subscribe(res => {
        if (res.content.checkAction == '0') {
          if (!this.webinarInfo.questionaryId || !this.isShowQuestion) {
            window.$sk.tips.show("资料暂未开放,敬请期待", {time: 1400});
            return
          } else {
            $subscriber.emit("showQuestion", "shoudong");
          }
        } else {
          let params = {
            instanceId: this.webinarInfo.instanceId,
            fileId: item.fileId,
            applicantId: this.user?.applicantId,
            globalUserId: ck.cookie("globalUserId"),
            title: item.name + "." + item.ext,
            sess: this.user?.session
          };
          ws.recordFileDownLoad(params).subscribe(data => {

          });
          window.open(item.fileCopyUrl + '&sourceDownload=1');
        }
      })
    },
    checkReplay(item,index){
      if(this.webinarInfo.replaySwitch != '1'){
        return;
      }
/*      window.$sk.webinar.skSdkEvent({
        type: "changeSeekVod",
        data: {
          time:'30'
        }
      });*/
      // console.log('window.$sk.webinar.sdk.player',window.$sk.webinar.sdk.player.plvLiveSdk.player.seek())
      this.scheduleList = this.scheduleList.map(item2=>{
        item2.isCurrent = false;
        if(item.theme == item2.theme){
          item2.isCurrent = true;
        }
        return item2;
      })
      if(window.$sk.webinar.sdk.player.nowVideo.videoType=='0'){
        window.$sk.webinar.sdk.player.plvLiveSdk.player.seek(item.timestamp);
      }else {
        window.$sk.webinar.sdk.player.plvDomainSdk.j2s_seekVideo(item.timestamp);
      }

      // $subscriber.emit("check-video-index", index);
/*      this.scheduleList = this.scheduleList.map(item2=>{
        item2.isCurrent = false;
        if(item.agendaId == item2.agendaId){
          item2.isCurrent = true;
        }
        return item2;
      })*/
    },
    getAgendaGroup(data, arr) {
      let newArry = []
      arr.forEach((item) => {
        data[item] && newArry.push(data[item])
      });
      return newArry
    },
    getCurrentAgenda(time){
      let currentIndex=-1
      this.originScheduleList.forEach((item,index)=>{
         if(item.timestamp<parseInt(time)||item.timestamp==parseInt(time)){
           currentIndex=index
         }
      });
      this.originScheduleList.forEach((item,index)=>{
        item.isCurrent = index === currentIndex
      });
    }
  },
 beforeDestroy() {
   clearInterval(this.getTimeLine)
 }
};
</script>

<style scoped></style>
